export const getHostName: Function = (): Object => {
    const hostName: string = window.location.hostname;
    const secure: boolean = (hostName === 'localhost' ? false : true)
    return { hostName, secure };
};

